import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useHostNavigate() {
    const navigate = useNavigate();
    const { search } = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const host = params.get('host');
    const shop = params.get('shop');

    return (to, options) => {
        const url = new URL(to, window.location.origin);
        const next = new URLSearchParams(url.search);
        if (host && !next.get('host')) next.set('host', host);
        if (shop && !next.get('shop')) next.set('shop', shop);
        const path = url.pathname + (next.toString() ? `?${next.toString()}` : '');
        navigate(path, options);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    };
}